import script from "./SogDataLabel.vue?vue&type=script&setup=true&lang=ts"
export * from "./SogDataLabel.vue?vue&type=script&setup=true&lang=ts"

import "./SogDataLabel.vue?vue&type=style&index=0&id=04e6b9c5&lang=css"

const __exports__ = script;

export default __exports__